import React from 'react';
import PropTypes from 'prop-types';

const VideoBackground = () => {
	return (
		<div
			style={{
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				zIndex: -1,
				overflow: 'hidden'
			}}
		>
			<video
				autoPlay
				loop
				muted
				playsInline
				style={{
					minWidth: '100%',
					minHeight: '100%',
					width: 'auto',
					height: 'auto',
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					objectFit: 'cover'
				}}
				src="https://www.pexels.com/download/video/31398068"
			/>
		</div>
	);
};

const SectionComponent = ({ videoSrc, children }) => {
	return (
		<section
			style={{
				position: 'relative',
				// height: '100vh',
				overflow: 'hidden'
			}}
		>
			<VideoBackground videoSrc={videoSrc} />
			<div style={{ position: 'relative', zIndex: 1 }}>{children}</div>
		</section>
	);
};

SectionComponent.propTypes = {
	children: PropTypes.any,
	videoSrc: PropTypes.any
};

export default SectionComponent;
